/**
 * Creates a new array of numbers starting from 1
 * @param N Upper bound of the array (inclusive)
 * @returns an array of numbers starting from 1
 * @example nary(5) --> [1, 2, 3, 4, 5]
 */
export default function nary(N: number) {
	// return Array.apply(null, {length: N}).map(Number.call, Number);
	// const o = [...Array(N).keys()].map(n => n++);
	return (!isNaN(N)) ?
		[...new Array(N + 1).keys()].slice(1) :
		[];
}
